import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth, useAuth } from '@/contexts/AuthContext';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Projects from '@/pages/Projects';
import CreateProject from '@/pages/CreateProject';
import Prospects from '@/pages/Prospects';
import Users from '@/pages/Users';
import Analytics from '@/pages/Analytics';
import HowWeWork from '@/pages/HowWeWork';
import { ChatWidget } from '@/components/chat';

function AuthenticatedChatWidget() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading || !isAuthenticated) return null;
  return <ChatWidget />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <AuthenticatedChatWidget />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/projects"
            element={
              <RequireAuth>
                <Projects />
              </RequireAuth>
            }
          />
          <Route
            path="/projects/new"
            element={
              <RequireAuth>
                <CreateProject />
              </RequireAuth>
            }
          />
          <Route
            path="/prospects"
            element={
              <RequireAuth>
                <Prospects />
              </RequireAuth>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAuth>
                <Users />
              </RequireAuth>
            }
          />
          <Route
            path="/analytics"
            element={
              <RequireAuth>
                <Analytics />
              </RequireAuth>
            }
          />
          <Route
            path="/how-we-work"
            element={
              <RequireAuth>
                <HowWeWork />
              </RequireAuth>
            }
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
